export default __webpack_public_path__ + "34431474ce3af0cb06cdb311d630958f.svg";